import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { upcommingProjects } from "../Helpers/projects";
import { projects } from "../Helpers/projects";
import { PulseLoader } from "react-spinners";

const projectsPageStyle = {
  backgroundColor: "#111",
  color: "#fff",
  padding: "16px",
  display: "flex",
  flexDirection: "column-reverse",
};

const headingStyle = {
  marginBottom: "16px",
};

const projectListStyle = {
  listStyle: "none",
  padding: 0,
  display: "flex",
  flexWrap: "wrap",
};

const projectItemStyle = {
  flexBasis: "calc(50% - 20px)",
  marginBottom: "16px",
  marginRight: "16px",
};

const buttonStyle = {
  background: "linear-gradient(45deg, #b02443 30%, #2e47e9 90%)",
  color: "#fff",
};

const Projects = () => {
  const [upcommingProjectss, setupcommingProjectss] = useState({
    isLoading: true,
    data: [],
  });
  const [projectss, setProjects] = useState({
    isLoading: true,
    data: [],
  });

  useEffect(() => {
    setupcommingProjectss({
      isLoading: false,
      data: upcommingProjects,
    });

    setProjects({
      isLoading: false,
      data: projects,
    });
  }, []);

  if (upcommingProjectss.isLoading || projectss.isLoading) {
    return (
      <div className="loader">
        <PulseLoader
          color={"#fff"}
          loading={projectss.isLoading}
          size={30}
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <div style={projectsPageStyle}>
      <div className="projects">
        <Typography variant="h5" style={headingStyle}>
          What I'm working on
        </Typography>
        <ul style={projectListStyle}>
          {upcommingProjectss.data.map((project) => (
            <li key={project.id} style={projectItemStyle}>
              <img src={project.img} alt={project.name} />
              <p>{project.name}</p>
              <Link to={`/uppcomingdetails/${project.id}`}>
                <Button variant="contained" style={buttonStyle}>
                  View Details
                </Button>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="projects">
        <Typography variant="h5" style={headingStyle}>
          What I've Built
        </Typography>
        <ul style={projectListStyle}>
          {projectss.data.map((project) => (
            <li key={project.id} style={projectItemStyle}>
              <img src={project.img} alt={project.name} />
              <p>{project.name}</p>
              <Link to={`/projectdetails/${project.id}`}>
                <Button variant="contained" style={buttonStyle}>
                  View Details
                </Button>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Projects;
